// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [customer, setCustomer] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // Load customer from localStorage on mount
    useEffect(() => {
        const savedCustomer = localStorage.getItem('customer');
        if (savedCustomer) {
            try {
                setCustomer(JSON.parse(savedCustomer));
            } catch (error) {
                console.error('Failed to parse saved customer:', error);
                localStorage.removeItem('customer');
            }
        }
        setIsLoading(false);
    }, []);

    const login = (customerData) => {
        setCustomer(customerData);
        localStorage.setItem('customer', JSON.stringify(customerData));
    };

    const logout = () => {
        setCustomer(null);
        localStorage.removeItem('customer');
    };

    const value = {
        customer,
        isAuthenticated: !!customer,
        isLoading,
        login,
        logout,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
